import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { JoinFlowProvider } from '@/pages/organizations/join/_components/JoinFlowContext'

export const Route = createFileRoute('/app/organizations/join/$orgtypeMachineName')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { orgtypeMachineName } = Route.useParams()
  return (
    <JoinFlowProvider orgTypeMachineName={orgtypeMachineName}>
      <Outlet />
    </JoinFlowProvider>
  )
}
